import { render, staticRenderFns } from "./CrmSelectAssigned.vue?vue&type=template&id=56ef1ef7"
import script from "./CrmSelectAssigned.vue?vue&type=script&lang=ts"
export * from "./CrmSelectAssigned.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ef1ef7')) {
      api.createRecord('56ef1ef7', component.options)
    } else {
      api.reload('56ef1ef7', component.options)
    }
    module.hot.accept("./CrmSelectAssigned.vue?vue&type=template&id=56ef1ef7", function () {
      api.rerender('56ef1ef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmSelectAssigned.vue"
export default component.exports